/**************************************************
 * Nombre:       Formulario_Profesional
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined} from "@mui/icons-material";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Educacion from "./Formulario_Educacion";
import Tarjetas_Educacion from "../Tarjeta/Tarjetas_Educacion";

const Formulario_Profesional = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'educacion',
        nombre: 'Agregar Item',
        Tarjeta: Tarjetas_Educacion,
        Formulario: Formulario_Educacion
    })

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={10} alto={7}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Imagen de maximo 500k (1000px por 700px)</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'Campo Requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Profesion'} dato={'profesion'}  {...props}
                                  requerido={'Campo Requerido'}
                    />

                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={6} nombre={'Resumen de Cv'} dato={'resumen'}  {...props}
                                  requerido={'Campo Requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Educacion y Experiencia</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Profesional